import React, { useContext, useEffect, useRef, useState } from 'react'
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import GloblePopup from "../common/GloblePopup";
import useSocket from '../global/Websoket.js';
import config from '../config.jsx';
import { GlobalContext } from '../global/GlobalProvider.jsx';
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import rip from "../assets/ripple_svg3.svg";
import FancyBookPopup from './FancyBookPopup.jsx';
import ScroreCard from '../components/ScroreCard.jsx';
import LiveTV from '../components/LiveTV.jsx';
import LayPricesBox from '../components/LayPricesBox.jsx';
import BackPricesBox from '../components/BackPricesBox.jsx';
import BMBackPriceBox from '../components/BMBackPriceBox.jsx';
import BMLayPriesBox from '../components/BMLayPriesBox.jsx';
import FancyNoValueBox from '../components/FancyNoValueBox.jsx';
import FancyYesValueBox from '../components/FancyYesValueBox.jsx';
import SubNotification from '../components/SubNotification.jsx';
import { Link, useNavigate } from 'react-router';
import MatchNotFound from './MatchNotFound.jsx';
import FBackPriceBox from '../components/FBackPriceBox.jsx';
import FLayPriesBox from '../components/FLayPriesBox.jsx';
import { useTranslation } from 'react-i18next';

export default function ExchangeInplay({eventId,mId}) {
   const { t, i18n } = useTranslation();
   const [apiResponse, setApiResponse] = useState();
   const [isStreamOpen, setStreamOpen] = useState(false);
   const navigate = useNavigate();
   const [scoreOrTvLive, setScoreOrTvLive] = useState('Score');
   const [isOpen, setIsOpen] = useState(null);
   const [isMobileBetsOpen, setIsMobileBetsOpen] = useState(null);
   const [matchStatuss, setMatchStatus] = useState(0);
   const [matchCheck, setMatchCheck] = useState('');
   const [key, setKey] = useState(0);
   let marketSortingMap = '';
   const handleClick = (section) => {
     if (isOpen === section) {
      setIsOpen('');
     } else {
      setIsOpen(section);
     }
   };

   const [marketID, setsetMakerID] = useState([]);
   const [matchOdd, setMatchOdd] = useState();
   const [underOver, setUnderOver] = useState();
   const [tideMatch, setTideMatch] = useState();
   const [bookmakerMarket, setBookmakerMarket] = useState();
   const [fancyData, setFancyData] = useState([]);
   const [allMinMax, setAllMinMax] = useState([]);
   const [usersideBook, setUserSideBook] = useState([]);
   const [stack, setStack] = useState([]);
   const [isFancyBookPopup, setFancyBookPopup] = useState(false);
   const [myNotification, setMyNotification] = useState();

   const {setLoginPop,loggedIn,stackArray,openSuccessPopup, openErrorPopup, setAlertMsg } = useContext(GlobalContext);
   const { isConnected, receivedBookUserSide, receivedBetlistData, receivedToken, sendMessage, receivedMinMax, receivedAllBookData, receivedcashoutMO, receivedcashoutBm, receivedBookFancy } = useSocket();
   let userInfo = sessionStorage.getItem('userinfo');
   let fancyType = ["SINGLE_OVER", "ODD_EVEN", "WINNING_SEATS", "BALL_BY_BALL","OTHER"]
   let fancyNormalType = ["OVERS", "BATSMAN"]
   const [isCashOut, setCashOut] = useState(false);

   const hasAnyFancyType = fancyNormalType.some((type) =>
      fancyData?.some((item) => item.category === type)
    );

   let matchDataAccess = {
      "eventId": eventId,
      "userId": '65fc48e7eab864a79776c01c'
  };
  if (userInfo) {
      userInfo = JSON.parse(userInfo);
      matchDataAccess = {
          "eventId": eventId,
          "userId": userInfo._id
      };

  }

   const checkGameStart = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      if(sessionStorage.getItem('loggedIn') || loggedIn){
      myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
      }

   const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/matchStatus?eventId=${eventId}`, requestOptions)
      .then(async (response) => {
         let paresData = await response.json();
         if(response.ok){
            setMatchStatus(paresData?.matchStatus === 'IN_PLAY' || paresData?.matchStatus === 'UPCOMING' ? 1 : 2)
         }else{
            setMatchStatus(2)
         }
         setMatchCheck(paresData?.matchStatus);
      })
      .catch((error) => {
         console.log(error);
      });
   };

   useEffect(() => {
      let gameCheckInterval;
         // Initial call
         checkGameStart();

         // Repeat every 30 seconds
         gameCheckInterval = setInterval(() => {
            checkGameStart();
         }, 30000);

      return () => {
         if (gameCheckInterval) clearInterval(gameCheckInterval);
      };
   }, []);

  const [scoresUrl, setScoreUrl] = useState("");
  const [tvUrl, setTvUrl] = useState("");
  const [tvUrlFalg, setTvUrlFlag] = useState(true);
  const [profitLossData, setProfitLossData] = useState({}); // Store dynamic data
  const [betlistData, setBetlistData] = useState(matchDataAccess);
  const iframeUrlRef = useRef("");
  const [updateDate, setUpdateDate] = useState(Date.now());

  useEffect(() => {
   const intervalId = setInterval(() => {
     if (Date.now() - updateDate + (5 * 1000)) {
         console.log("Updateed Data");
     }else{
         console.log("check tryto connect socket");
         
         startWebSocket();
     }
   }, 1000); // Update every 1 second
 
   return () => clearInterval(intervalId); // Cleanup on unmount
 }, []);

  useEffect(()=>{
   console.log(receivedBetlistData, "receivedBetlistDatareceivedBetlistData");
   
   if (receivedBetlistData?.bets?.MatchOdds?.length > 0) {
      setIsMobileBetsOpen("Match Odds");
    } else if (receivedBetlistData?.bets?.bookmaker?.length > 0) {
      setIsMobileBetsOpen("bookmaker");
    } else if (receivedBetlistData?.bets?.normal?.length > 0) {
      setIsMobileBetsOpen("normal");
    } else if (receivedBetlistData?.bets?.oddEven?.length > 0) {
      setIsMobileBetsOpen("oddEven");
    }
  },[receivedBetlistData])

  const callScoreAPI = async (data)=>{
       const myHeaders = new Headers();
       myHeaders.append("Content-Type", "application/json");
       myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

       const raw = JSON.stringify({
         "whiteLabelName": config.WhiteLable,
         "eventId":data?.matchData?.eventId,
         "sportId":data?.matchData?.sportId
       });

       const requestOptions = {
       method: "POST",
       headers: myHeaders,
       body: raw,
       redirect: "follow"
       };

   fetch(`${process.env.REACT_APP_BASE_URL}/getScoreCard`, requestOptions)
   .then(async (response) => {
     let paresData = await response.json();
     let url = '';
     if (data?.matchData?.sportId == "4") {
      url = `https://scorebae.com/sportslive/sbtcarbon/cricket/${data?.matchData?.eventId}`
     }else if (data?.matchData?.sportId == "1") {
      // football
      url = `https://scorebae.com/sportslive/sbtcarbon/soccer/${data?.matchData?.eventId}`
     }else if (data?.matchData?.sportId == "2") {
      // tennis
      url = `https://scorebae.com/sportslive/sbtcarbon/tennis/${data?.matchData?.eventId}`
     }
   //   if(apiResponse?.matchData?.isvirtual){
      setScoreUrl(paresData.scorecard); 
   //   }else{
      // setScoreUrl(`<iframe src=${url} width="100%"></iframe>`);
   //   }
     

      setTvUrl(paresData.livestreme);
     setTvUrlFlag(false)
   })
   .catch((error) => {
     console.log(error);
   });
 }

  useEffect(()=>{
   if (receivedAllBookData) {
       setProfitLossData([]);
       if (Array.isArray(receivedAllBookData.showData) && receivedAllBookData.showData.length > 0) {
           receivedAllBookData.showData.forEach(marketData => {
               Object.entries(marketData).forEach(([marketId, runners]) => {
                   runners.forEach(({ runnerId, amount }) => {
                       updateProfitLoss(marketId, runnerId, amount);
                   });
               });
           });
       }
   }

},[receivedAllBookData])

useEffect(() => {
   sendMessage('getbetlistdata2', betlistData);
   const intervalId = setInterval(() => {
       sendMessage('getbetlistdata2', betlistData);
   }, 5000);
   return () => {clearInterval(intervalId);}
}, [apiResponse,isConnected]);

useEffect(() => {
   if (Object.keys(receivedcashoutMO).length > 0 && receivedcashoutMO.secId) {
       setCashOut(true);
       config.DATA = {
           eventId: receivedcashoutMO.eventId,
           marketId: receivedcashoutMO.marketId,
           stake: receivedcashoutMO.stake,
           betType: receivedcashoutMO.betType,
           selectionName: receivedcashoutMO.runnerName,
           odds: receivedcashoutMO.odds,
           marketData:receivedcashoutMO,
           marketType: receivedcashoutMO.marketType,
           secId: `${receivedcashoutMO.secId}`,
           isCashout: true,
           isFancy:config.isNotfancy
       }
       setBetsData({
           eventId: receivedcashoutMO.eventId,
           marketId: receivedcashoutMO.marketId,
           stake: receivedcashoutMO.stake,
           betType: receivedcashoutMO.betType,
           selectionName: receivedcashoutMO.runnerName,
           odds: receivedcashoutMO.odds,
           marketData:receivedcashoutMO,
           marketType: receivedcashoutMO.marketType,
           secId: `${receivedcashoutMO.secId}`,
           isCashout: true,
           isFancy:config.isNotfancy
       });
       setIsBetSlipOpen(true);
   }
}, [receivedcashoutMO]);

useEffect(() => {
   if (Object.keys(receivedcashoutBm).length > 0 && receivedcashoutBm.secId) {
       setCashOut(true);

       config.DATA = {
           eventId: receivedcashoutBm.eventId,
           marketId: receivedcashoutBm.marketId,
           stake: receivedcashoutBm.stake,
           betType: receivedcashoutBm.betType,
           selectionName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).runners.find(item => item.runnerId == receivedcashoutBm.secId).runnerName,
           odds: receivedcashoutBm.odds,
           marketType: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketType,
           marketData:apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId),
           secId: `${receivedcashoutBm.secId}`,
           isCashout: true,
           marketName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketName,
           isFancy:config.isNotfancy
       }
       setBetsData({
           eventId: receivedcashoutBm.eventId,
           marketId: receivedcashoutBm.marketId,
           stake: receivedcashoutBm.stake,
           betType: receivedcashoutBm.betType,
           selectionName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).runners.find(item => item.runnerId == receivedcashoutBm.secId).runnerName,
           odds: receivedcashoutBm.odds,
           marketData:apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId),
           marketType: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketType,
           secId: `${receivedcashoutBm.secId}`,
           isCashout: true,
           marketName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketName,
           isFancy:config.isNotfancy
       });
       setIsBetSlipOpen(true);
   }
}, [receivedcashoutBm]);

const updateBook = (oldStack, newStack) => {
   if (betsData.marketData && Object.keys(betsData.marketData).length > 0 ) {
       let newvalue = newStack;
       let oldvalue = oldStack;

       let oddsValue = betsData.odds;
       let currentRunnerID = betsData.secId;
       let currentMakertID = betsData.marketId;
       let currentRunnerPL = profitLossData[`${currentMakertID}_${currentRunnerID}`]
       let otehrRunnerID = betsData.marketData?.runners?.filter(item => item.runnerId != betsData.secId) || [];
       let addValueCurrentRunn = 0
       let addvalueOther = 0
       let diff = 0
       let marketType = betsData?.marketData?.marketType
       console.log(oldStack, newStack, betsData.betType,betsData?.marketData?.marketType);

       if(betsData.betType === config.back){
           if(newStack > oldStack){
               console.log('gfgfgf');
               diff = Math.abs(newStack - oldStack)
               if(marketType == 'BOOKMAKER'){
                   addValueCurrentRunn = (diff * oddsValue) / 100
                   addvalueOther = - diff
               }else{
                   addValueCurrentRunn = (diff * oddsValue) - diff
                   addvalueOther = - diff
               }
           }else if(newStack < oldStack){
               diff = Math.abs(oldStack-newStack)
               if(marketType == 'BOOKMAKER'){
                   addValueCurrentRunn = - Math.abs((diff * oddsValue) / 100)
                   addvalueOther =  diff
               }else{
                   addValueCurrentRunn = - Math.abs((diff * oddsValue) - diff)
                   addvalueOther = diff
               }

           }

       }else{
           if(newStack > oldStack){
               diff = Math.abs(newStack - oldStack)
               if(marketType == 'BOOKMAKER'){
                   addValueCurrentRunn =  - ((diff * oddsValue) / 100)
                   addvalueOther = diff
               }else{
                   addValueCurrentRunn =  - ((diff * oddsValue) - diff)
                   addvalueOther = diff
               }
           }else if(newStack < oldStack){
               diff = Math.abs(oldStack-newStack)
               if(marketType == 'BOOKMAKER'){
                   addValueCurrentRunn =   Math.abs((diff * oddsValue) / 100)
                   addvalueOther =  - diff
               }else{
                   addValueCurrentRunn =  Math.abs((diff * oddsValue) - diff)
                   addvalueOther = - diff
               }

           }
       }
       updateProfit(betsData.marketId,currentRunnerID,addValueCurrentRunn)
       for (let i = 0; i < otehrRunnerID.length; i++) {
           const element = otehrRunnerID[i].runnerId;
           updateProfit(betsData.marketId,element,addvalueOther)
       }
   }
}

const updateProfitLoss = (marketId, runnerId, value) => {
   setProfitLossData(prev => ({
       ...prev,
       [`${marketId}_${runnerId}`]: formatNumberrr(value) // Store data for each marketId & runnerId
   }));
};
const formatNumberrr = (num) => {
   const str = num.toString();
   const dotIndex = str.indexOf(".");

   // If there is no decimal point, return as is
   if (dotIndex === -1) return num;

   // Extract up to two decimal places without rounding
   return str.substring(0, dotIndex + 3);
};
const updateProfit = (marketId, runnerId, value) => {
   setProfitLossData(prev => {
       const key = `${marketId}_${runnerId}`;
       const existingValue = prev[key] ? parseFloat(prev[key]) : 0; // Get existing value or default to 0
       return {
           ...prev,
           [key]: formatNumberrr(existingValue + value) // Add to existing value
       };
   });
};

   let subscribeChannels = useRef([]);
   const wsRef = useRef(null);
   const heartbeatRef = useRef(null);
   let heartbeatInterval;

   let isOneClicked = sessionStorage.getItem('isOneClicked')
   let oneClickValue
   if(isOneClicked == 'true'){
       oneClickValue = sessionStorage.getItem('oneClickAmount')
   }

   const [count, setCount] = useState(0);
   const [betOnProcess, setBetOnProcess] = useState(false);
   const [isBetSlipOpen, setIsBetSlipOpen] = useState(false);
   const [isMobileBets, setIsMobileBets] = useState(false);
    let countIntervalId = null;

   const [betsData,setBetsData] = useState({
      eventId: '',
      marketId: '',
      stake: '',
      betType: '',
      selectionName: '',
      marketName: '',
      odds: '',
      rate: '',
      marketData:{},
      isFancy:''
  });

   useEffect(()=>{
      setUserSideBook(receivedBookUserSide);
      // console.log(receivedBookUserSide,"receivedBookUserSide");

   },[receivedBookUserSide])

   useEffect(() => {
      setAllMinMax(receivedMinMax.minmaxdata);
      // console.log(receivedMinMax.minmaxdata,"receivedMinMax.minmaxdatareceivedMinMax.minmaxdata");

   }, [receivedMinMax])

   const publicKeyPEM = `-----BEGIN PUBLIC KEY-----
   MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKik5c/NUnfRBlOR6fgoSwG5YMEgclwe
   BBcPrHR452svxh9lPPNUr8stKqglGU40+ilIzXlsKlZ1sMKh4w6+O6MCAwEAAQ==
   -----END PUBLIC KEY-----`;

   // Generate AES key
   const generateAESKey = () => {
       return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex); // 16-byte key
   };

   // Encrypt with AES
   const encryptWithAES = (text, key) => {
       return CryptoJS.AES.encrypt(text, key).toString();
   };

   // Encrypt AES Key with RSA
   const encryptAESKeyWithRSA = (aesKey) => {
       return new Promise((resolve, reject) => {
           const encryptor = new JSEncrypt();
           encryptor.setPublicKey(publicKeyPEM);
           const encryptedKey = encryptor.encrypt(aesKey);

           if (encryptedKey) {
               resolve(encryptedKey);
           } else {
               reject("RSA Encryption failed!");
           }
       });
   };

   // Main function
   const encryptLargeMessage = async (message) => {
       try {
           const aesKey = generateAESKey(); // Step 1: Generate AES Key
           const encryptedMessage = encryptWithAES(message, aesKey); // Step 2: Encrypt Message

           // Step 3: Encrypt AES Key with RSA (using await)
           const encryptedAESKey = await encryptAESKeyWithRSA(aesKey);

           return {
               encryptedMessage,
               encryptedAESKey
           };
       } catch (error) {
           console.error("Encryption failed:", error);
       }
   };

   const SendBookDetails_MB = () => {
      let userinfo = sessionStorage.getItem('userinfo');
      if (userinfo && eventId) {
          userinfo = JSON.parse(userinfo);
          sendMessage('marketIdbookDetailsByEventId', { eventId, user: userinfo });
      } else if(!userinfo){
          sendMessage('marketIdbookDetailsByEventId', { eventId });
      }else{
          console.error('Missing eventId or marketId');
      }
  };

   const sendBetList = () =>{
       sendMessage('getbetlistdata2', betlistData);
   }

   useEffect(() => {
       const encryptData = async () => {
           let final = {};
           if (receivedToken.token) {
               console.log(receivedToken.token, "receivedTokenreceivedTokenreceivedToken");
               let user = JSON.parse(sessionStorage.getItem('userinfo'));
               let string = `${user._id}_${receivedToken.token}_${user.userName}`;
               // Encrypt data
               const enc = await encryptLargeMessage(string);
               let msg = `${enc.encryptedAESKey}_token_${enc.encryptedMessage}`
               let aaa = isOneClicked === "true" ? config.DATA : betsData
               if (!isCashOut) {
                   if (isOneClicked === "true") {
                       aaa.stake = oneClickValue
                   }

                   final = {
                       ...aaa,    // If there's any existing data, retain it
                       msg: msg , // Add the new token
                   };
               }else{
                   let asd = config.DATA
                   final = {
                       ...asd,    // If there's any existing data, retain it
                       msg: msg , // Add the new token
                   };
               }

               try {
                   // Replace 'your-token' with your actual token
                   const myHeaders = new Headers();
                   myHeaders.append("Content-Type", "application/json");
                   myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
                   console.log("request :::::: ", final)
                   const requestOptions = {
                       method: "POST",
                       headers: myHeaders,
                       redirect: "follow",
                       body: JSON.stringify(final)
                     };

                     fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/bets/placeBet_world`, requestOptions)
                     .then(async (response) => {
                       if (response.ok) {
                           let result = await response.json();
                           sendBetList();
                           openSuccessPopup();
                           setBetOnProcess(false);
                           clearInterval(countIntervalId);
                           setAlertMsg(result.msg);
                           handleResetBtn();
                           config.DATA = {}
                           SendBookDetails_MB();
                           setCashOut(false);
                       } else{
                           let errorResult = await response.json(); // Parse the JSON error response
                           sendBetList();
                           openErrorPopup();
                           setAlertMsg(errorResult.message);
                           setBetOnProcess(false);
                           clearInterval(countIntervalId);
                           config.DATA = {};
                           handleResetBtn();
                           setCashOut(false);
                           SendBookDetails_MB();
                       }

                     })
                     .catch(async (error) => {
                       sendBetList();
                       SendBookDetails_MB();
                       setCashOut(false);
                       setBetOnProcess(false)
                       clearInterval(countIntervalId);
                       config.DATA = {};
                       handleResetBtn();
                       console.log(error);
                       SendBookDetails_MB();
                     });

               } catch (error) {
                   sendBetList();
                   SendBookDetails_MB();
                   setBetOnProcess(false)
                   clearInterval(countIntervalId);
                   setCashOut(false);
                   handleResetBtn();
                   console.error('Error fetching API data:', error);
               }
           }
       };
       encryptData();
   }, [receivedToken])

   const getTitleName = (type) => {
      if (type === "OVERS") {
         return "Session";
      } else if (type === "SINGLE_OVER") {
         return "Only Over";
      } else if (type === "BATSMAN") {
         return "W/P Market";
      } else if (type === "ODD_EVEN") {
         return "Odd Even";
      } else if (type === "WINNING_SEATS") {
         return "Winning Seats";
      } else if (type === "BALL_BY_BALL") {
         return "Ball by Ball";
      } else if (type === "OTHER") {
         return "xtra market";
      }
   }

   const getName = (type) => {
      if (type === "OVERS") {
         return "Session";
      } else if (type === "SINGLE_OVER") {
         return "onlyOver";
      } else if (type === "BATSMAN") {
         return "W/P Market";
      } else if (type === "ODD_EVEN") {
         return "OddEven";
      } else if (type === "WINNING_SEATS") {
         return "WinningSeats";
      } else if (type === "BALL_BY_BALL") {
         return "BallByBall";
      } else if (type === "OTHER") {
         return "Other";
      }
   }

   useEffect(() => {
      unsubscribeAll();
      setApiResponse();
      setsetMakerID();
      setMatchOdd();
      setBookmakerMarket();
      setFancyData();
      setsetMakerID([]);
      setKey(prevKey => prevKey + 1);
      fetchData(eventId);
      getSubNotification();
   }, [eventId,mId]);

   const getMyMinMax = (id) => {
      if (allMinMax && allMinMax.length > 0) {
         let data = allMinMax.find(item => item.marketId.toString() === id.toString());
         return (<><span>{`Min: ${data?.min_stake ? data?.min_stake : '0'} `}</span> <span>{`Max: ${data?.max_stake ? formatNumberNotFiex(parseFormattedNumber(data?.max_stake)) : "0"}`}</span></>);
      }
   }

   const getMyBook = (id) => {
      if (usersideBook && usersideBook.length > 0) {
         let data = usersideBook.find(item => item.marketId.toString() === id.toString());
         return data?.book;
      }
   }

   const getMyBookcheck = (id) => {
      if (usersideBook && usersideBook.length > 0) {
         let data = usersideBook.find(item => item.marketId.toString() === id.toString());
         return data?.book > 0;
      }
   }

   const getMyMax = (id) => {
      if (allMinMax && allMinMax.length > 0) {
         let data = allMinMax.find(item => item.marketId.toString() === id.toString());
         return data?.max_stake;
      }
   }

   useEffect(() => {
      try{
          setStack(JSON.parse(stackArray));
      }catch(err){
          setStack(stackArray)
      }
  }, [stackArray]);

     useEffect(() => {
      const interval = setInterval(() => {
         if (wsRef.current && wsRef.current.readyState === WebSocket.CLOSED) {
            console.log('WebSocket connection closed, attempting to reconnect...');
            startWebSocket();   
         }else{
            console.log('DONEDONEDONE');
         }
      }, 15000); // every 15s

      return () => clearInterval(interval);
      }, []);

   const startWebSocket = () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
         console.log("WebSocket is already open. Skipping new connection.");
         return;
       }
      const marketTideTypes = ["TIED_MATCH"];
      const marketMatchOdds = ["Match Odds"];
      const marketTypes = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN"];
      const marketKeys = ["OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15"];

      let matchOddsArray = apiResponse?.matchData?.markets?.matchOdds || [];

      let selectTideMatch = [
         matchOddsArray.find((item) => marketTideTypes.includes(item.marketType))?.marketId
      ]

      let dataMOId = [
          matchOddsArray.find((item) => marketTypes.includes(item.marketType))?.marketId,
          ...marketKeys.map((key) => matchOddsArray.find((item) => item.marketType === key)?.marketId)
      ].filter(Boolean);


      const marketNames = ["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"];

      let bookmakers = apiResponse?.matchData?.markets?.bookmakers || [];

      let dataBMId = [
        ...marketNames.map((name) => bookmakers.find((item) => item.marketName === name)?.marketId),
        bookmakers.find((item) => item.bettingType === "BOOKMAKER" && !marketNames.includes(item.marketName))?.marketId
      ].filter(Boolean);

      let ws = new WebSocket(config.wssLink);

      wsRef.current = ws;

      ws.onopen = () => {
        console.log('11111--Connected to WebSocket server');

        for (let indexMo = 0; indexMo < dataMOId.length; indexMo++) {
          const element = dataMOId[indexMo];
          if (!subscribeChannels.current.includes(`${config.Topic_Match_Odds}${element}`)) {
            ws.send(JSON.stringify({ action: 'subscribe', topic: `${config.Topic_Match_Odds}${element}` }));
            subscribeChannels.current.push(`${config.Topic_Match_Odds}${element}`);
          }
        }

        for (let indexBM = 0; indexBM < dataBMId.length; indexBM++) {
          const element = dataBMId[indexBM];
          if (!subscribeChannels.current.includes(`${config.Topic_Bookmaker}${element}`)) {
            ws.send(JSON.stringify({ action: 'subscribe', topic: `${config.Topic_Bookmaker}${element}` }));
            subscribeChannels.current.push(`${config.Topic_Bookmaker}${element}`);
          }
        }

        const topic = `${config.Topic_Fancy}${eventId}`;

        if (!subscribeChannels.current.includes(topic)) {
          ws.send(JSON.stringify({ action: 'subscribe', topic }));
          subscribeChannels.current.push(topic);
        } else {
          console.log(subscribeChannels.current, "Fancy already subscribe");
        }

        if (heartbeatRef.current) {
         clearInterval(heartbeatRef.current);
       }
       heartbeatRef.current = setInterval(() => {
         if (ws.readyState === WebSocket.OPEN) {
           ws.send(JSON.stringify({ action: 'ping' }));
         } else {
           clearInterval(heartbeatRef.current);
           reconnectWebSocket();
         }
       }, 3000);
      };

      ws.onmessage = (event) => {
        const { topic, marketData } = JSON.parse(event.data);
        setUpdateDate(Date.now());
        if (marketData) {
          const parsedData = JSON.parse(marketData);

          if (topic.startsWith(`${config.Topic_Match_Odds}`)) {
            console.log(parsedData,"111111111111111");
            
            if (marketTideTypes.includes(parsedData.marketType)) {
               setTideMatch((prevMOData) => ({
                  ...prevMOData,
                  [`${topic.split('/').pop()}`]: parsedData,
                }));
            }
            if (marketKeys.includes(parsedData.marketType)) {
               setUnderOver((prevMOData) => ({
                  ...prevMOData,
                  [`${topic.split('/').pop()}`]: parsedData,
                }));
            }
            // console.log(parsedData.marketName);
             if (marketMatchOdds.includes(parsedData.marketName)) {
               // console.log(parsedData,"parsedDataparsedDataparsedData");
               
               const runners = parsedData.runners || [];
               const names = runners.map(r => r.runnerName);
               const isAZ = [...names].sort().join() === names.join(); // A->Z check

               marketSortingMap = isAZ ? 'AZ' : 'ZA';
               setMatchOdd((prevMOData) => ({
                  ...prevMOData,
                  [`${topic.split('/').pop()}`]: parsedData,
                }));
            }

             if (['WIN'].includes(parsedData.marketType)) {
               // console.log(parsedData,"parsedDataparsedDataparsedData");
               
               const runners = parsedData.runners || [];
               const names = runners.map(r => r.runnerName);
               const isAZ = [...names].sort().join() === names.join(); // A->Z check

               marketSortingMap = isAZ ? 'AZ' : 'ZA';
               setMatchOdd((prevMOData) => ({
                  ...prevMOData,
                  [`${topic.split('/').pop()}`]: parsedData,
                }));
            }
          }

          if (topic.startsWith(`${config.Topic_Fancy}`)) {
            // console.log(parsedData,topic);

            let otherData = parsedData.filter((item) => item.status.trim() != 'CLOSED');
            let ids = marketID
            otherData.forEach((item) => {
              if (ids && !ids.includes(item.marketId.toString())) {
                  ids.push(item.marketId.toString());
              }
          });

          let marketIdArray = [
              ...selectTideMatch,
              ...dataMOId,
              ...dataBMId,
              ...ids
           ].filter(Boolean);

          setsetMakerID(marketIdArray);
            setFancyData(otherData);

          }

          if (topic.startsWith(`${config.Topic_Bookmaker}`)) {
            const bookmakerSorting = marketSortingMap; // 'AZ' or 'ZA'
            if (bookmakerSorting && parsedData.runners) {
               parsedData.runners.sort((a, b) => {
                 return bookmakerSorting === 'AZ'
                   ? a.runnerName.localeCompare(b.runnerName)
                   : b.runnerName.localeCompare(a.runnerName);
               });
             }
            //  console.log(parsedData,topic);
            setBookmakerMarket((prevBMData) => ({
              ...prevBMData,
              [`${topic.split('/').pop()}`]: parsedData,
            }));
          }
        }
      };

      ws.onclose = () => {
         console.log('WebSocket disconnected');
         subscribeChannels.current = [];
         unsubscribeAll();
         clearInterval(heartbeatRef.current);
         if (window.location.pathname.startsWith('/exchange_inPlay')) {
            reconnectWebSocket();
        } 
      };

      ws.onerror = (error) => {
        console.log('11111--WebSocket error:', error);
        subscribeChannels.current = [];
        unsubscribeAll();
        clearInterval(heartbeatInterval);
        if (window.location.pathname.startsWith('/exchange_inPlay')) {
         reconnectWebSocket();
     } 
      };
    };

    const reconnectWebSocket = () => {
      console.log('Reconnecting WebSocket...');
      if (wsRef.current) {
        wsRef.current.close();
      }
      setTimeout(() => {
        startWebSocket();
      }, 3000);
    };

    const unsubscribeAll = () => {
      // if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        subscribeChannels.current.forEach((topic) => {
          wsRef.current.send(JSON.stringify({ action: 'unsubscribe', topic }));
        });
      //   subscribeChannels.current = [];
      // }
    };

       useEffect(() => {
        const handleVisibilityChange = () => {
          if (!document.hidden) {
            console.log("Tab is active again, reconnecting WebSocket...");
            startWebSocket();
          }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []); // Runs only once on mount

    const parseFormattedNumber = (input) => {
      if (input == null || input === '') return 0;

      const str = input.toString().trim();
      const suffix = str.slice(-1).toUpperCase();
      const num = parseFloat(str);

      if (isNaN(num)) return 0;

      switch (suffix) {
        case 'K':
          return num * 1000;
        case 'M':
          return num * 1000000;
        case 'B':
          return num * 1000000000;
        default:
          return num; // Plain number or string with no suffix
      }
    };

    const getSocketStatusText = (state) => {
      switch (state) {
        case 0: return 'Connecting';
        case 1: return 'Open';
        case 2: return 'Closing';
        case 3: return 'Closed';
        default: return 'Unknown';
      }
    };

    useEffect(() => {
      const interval = setInterval(() => {
        console.log("WebSocket state:", getSocketStatusText(wsRef.current?.readyState)); // 0: CONNECTING, 1: OPEN, 2: CLOSING, 3: CLOSED
      }, 10000); // every 10 seconds

      return () => clearInterval(interval); // cleanup on unmount
    }, []);

   useEffect(() => {
      if (!apiResponse || !apiResponse.matchData || !apiResponse.matchData.markets) return;
      console.log(apiResponse, "responseresponseresponseresponseresponse");
      callScoreAPI(apiResponse);
      let { markets } = apiResponse.matchData;
      let selectedMatchOdds,selectedUnderOver,selectTideMatch;

      const overUnderMarkets = ["OVER_UNDER_05", "OVER_UNDER_15", "OVER_UNDER_25"];
      const generalMarkets = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN"];

      const marketTideTypes = ["TIED_MATCH"];

      if (mId && mId !== "" && mId != null) {
         selectedMatchOdds = markets.matchOdds?.filter(
            (item) =>
               generalMarkets.includes(item.marketType) &&
               item.marketId.toString() === mId.toString()
         ) || [];

         selectTideMatch = markets.matchOdds?.filter(
            (item) =>
               marketTideTypes.includes(item.marketType) &&
               item.marketId.toString() === mId.toString()
         ) || [];

         selectedUnderOver = markets.matchOdds?.filter(
            (item) =>
               overUnderMarkets.includes(item.marketType) &&
               item.marketId.toString() === mId.toString()
         ).sort(
            (a, b) => overUnderMarkets.indexOf(a.marketType) - overUnderMarkets.indexOf(b.marketType)
         ) || [];
      } else {
         selectedMatchOdds = markets.matchOdds?.filter(
            (item) => generalMarkets.includes(item.marketType)
         ) || [];

         selectTideMatch = markets.matchOdds?.filter(
            (item) => marketTideTypes.includes(item.marketType)
         ) || [];

         selectedUnderOver = markets.matchOdds?.filter(
            (item) => overUnderMarkets.includes(item.marketType)
         ).sort(
            (a, b) => overUnderMarkets.indexOf(a.marketType) - overUnderMarkets.indexOf(b.marketType)
         ) || [];
      }

      let selectedBookmakers = markets.bookmakers.filter(
         (item) =>
            ["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"].includes(item.marketName) ||
            item.bettingType === "BOOKMAKER" && !["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"].includes(item.marketName)
      );


      let fancyMarketsArray = markets.fancyMarkets.filter((item) =>
         ["OVERS", "SINGLE_OVER", "BATSMAN", "ODD_EVEN", "WINNING_SEATS", "BALL_BY_BALL","OTHER"].includes(item.category)
      );

      let marketIdArray = [
         ...selectedMatchOdds.map(item => item.marketId),
         ...selectTideMatch.map(item => item.marketId),
         ...selectedUnderOver.map(item => item.marketId),
         ...selectedBookmakers.map(item => item.marketId),
         ...fancyMarketsArray.map(item => item.marketId)
      ].filter(Boolean);

      selectedMatchOdds.forEach((item) => {
         const runners = item.runners || [];
         const names = runners.map(r => r.runnerName);
         const isAZ = [...names].sort().join() === names.join(); // A->Z check

         marketSortingMap = isAZ ? 'AZ' : 'ZA';


         setMatchOdd((prevMOData) => ({
            ...prevMOData,
            [`${item.marketId}`]: item,
         }));
      });
      selectTideMatch.forEach((item) => {
         setTideMatch((prevMOData) => ({
            ...prevMOData,
            [`${item.marketId}`]: item,
         }));
      });

      selectedUnderOver.forEach((item) => {
         setUnderOver((prevMOData) => ({
            ...prevMOData,
            [`${item.marketId}`]: item,
         }));
      });

      selectedBookmakers.forEach((item) => {
            const sortDir = marketSortingMap;
            item.runners.sort((a, b) => {
               return sortDir === 'AZ'
                  ? a.runnerName.localeCompare(b.runnerName)
                  : b.runnerName.localeCompare(a.runnerName);
            });

         setBookmakerMarket((prevMOData) => ({
            ...prevMOData,
            [`${item.marketId}`]: item,
         }));
      });

      setsetMakerID(marketIdArray);
      setFancyData(fancyMarketsArray);
      startWebSocket();
      SendBookDetails_MB();
   }, [apiResponse]);

   const fetchData = (id) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
         method: "GET",
         headers: myHeaders,
         redirect: "follow",
      };

      fetch(
         `${process.env.REACT_APP_BASE_URL}/api/v1/games/getInPlayMatchData?id=${id}`,
         requestOptions
      )
         .then(async (response) => {
            if (response.ok) {
            let paresData = await response.json();
            setApiResponse(paresData);
            }else{
               let errorResult = await response.json();
               setAlertMsg(errorResult.message);
               openErrorPopup();
               navigate(`${config.isWhiteLabel ? '/sport' :'/'}`);
            }
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const formatDate = (eventDate) => {
      const date = new Date(eventDate);

      return new Intl.DateTimeFormat('en-GB', {
         year: 'numeric',
         month: '2-digit',
         day: '2-digit',
         hour: '2-digit',
         minute: '2-digit',
         second: '2-digit',
         hour12: false,
         timeZoneName: 'short'
      }).format(date);
   };

   const validation = (price) => {
      if (price &&
         price != '-' &&
         price != 0) {
         return true
      } else {
         return false
      }
   }

   const validationBM = (price) => {
      if (price &&
         price != '-' &&
         price != 0) {
         return true
      } else {
         return false
      }
   }

   const formatNumber = (num) => {
      if (num >= 10000000) {
         return (num / 10000000).toFixed(2) + 'Cr'; // Crore
      } else if (num >= 100000) {
         return (num / 100000).toFixed(2) + 'L'; // Lakh
      } else if (num >= 1000) {
         return (num / 1000).toFixed(2) + 'K'; // Thousand
      } else {
         return num.toString(); // Less than 1000
      }
   };

   const formatNumberNotFiex = (num) => {
      if (num >= 10000000) {
         return (num / 10000000) + 'Cr'; // Crore
      } else if (num >= 100000) {
         return (num / 100000) + 'L'; // Lakh
      } else if (num >= 1000) {
         return (num / 1000) + 'K'; // Thousand
      } else {
         return num.toString(); // Less than 1000
      }
   };

   const getBoxValue = (runner) => {
      return <>
         {validation(runner.price) ? runner.price : getLock()}
         <small>
            {validation(runner.size) ? formatNumber(runner.size) : getLock()}
         </small>
      </>
   }

   const getBMBoxValue = (runner,marketId,value,mainrunner) => {
      let valuez = mainrunner?.backPrices?.[0]?.price;
      let main = 0;
      if (valuez > 100) {
         main = parseFormattedNumber(getMyMax(marketId)) / 4
      }else{
         main = 0;
      }

      return <>
         {validation(runner.price) ? runner.price : getLock()}
         <small>{main === 0 ? formatNumberNotFiex(parseFormattedNumber(getMyMax(marketId))):formatNumberNotFiex(main)}</small>
      </>
   }

   const getLock = () => {
      // <img src='../images/lock.svg' alt='as'/>
      return '—'
   }

   const checkFancyAdminIsSuspend = (id) =>{
      if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
          return data?.resumesuspendstatus;
          }else{
              return false;
          }
  }

   const fancySuspend = (session) =>{
      if (checkFancyAdminIsSuspend(session.marketId)) {
          if(session.status !== "OPEN"){
              return <div className="suspended">{session.status}</div>
          }
      }else{
          return <div className="suspended">SUSPENDED</div>
      }
  }

  const isFancySuspend = (session) =>{
   if (checkFancyAdminIsSuspend(session.marketId)) {
       if(session.status !== "OPEN"){
           return "lock"
       }
   }else{
       return "lock"
   }
}

   // Effect for 'getmarketminmaxdata'
   useEffect(() => {
      if (!isConnected || !apiResponse) return;

    // Call once when dependencies change

      const sendMarketUpdates = () => {
         let data;
         let userData = sessionStorage.getItem('userId')
         if (userData) {
            data = {
               userId: sessionStorage.getItem('userId'),
               marketIds: marketID,
               eventId: eventId
            };
         } else {
            data = {
               userId: '64db25fa1617ac95db367a0d',
               marketIds: marketID,
               eventId: eventId
            };

         }
         // console.log(marketID, 'datdatdatdatdtadad')
         sendMessage('getmarketminmaxdata_world', data);
      };

      sendMarketUpdates(); // Send immediately
      const intervalId = setInterval(sendMarketUpdates, 3000);

      return () => { clearInterval(intervalId) };
   }, [apiResponse, isConnected, marketID]);


   useEffect(() => {
      if (!isConnected || !apiResponse) return;

    // Call once when dependencies change

      const sendMarketUpdates = () => {
         let data;
         let userData = sessionStorage.getItem('userId')
         if (userData) {
            data = {
               userId: sessionStorage.getItem('userId'),
               marketIds: marketID,
            };
         } else {
            data = {
               userId: '64db25fa1617ac95db367a0d',
               marketIds: marketID,
            };

         }
         // console.log(marketID, 'datdatdatdatdtadad')
         sendMessage('fancyBookUserSide', data);
      };

      sendMarketUpdates(); // Send immediately
      const intervalId = setInterval(sendMarketUpdates, 3000);

      return () => { clearInterval(intervalId) };
   }, [apiResponse, isConnected, marketID]);


   const checkAdminIsSuspend = (id) => {
      if (allMinMax && allMinMax.length > 0) {
         let data = allMinMax.find(item => item.marketId.toString() === id.toString());
         return data?.resumesuspendstatus;
      } else {
         return false;
      }
   }

   const getSuspendedMatchOdds = (status, matchOdd) => {
      if (!checkAdminIsSuspend(matchOdd.marketId)) {
         if (matchOdd.status == "OPEN") {
            if (status != "ACTIVE") {
               return <div className="suspended">{status}</div>
            }
         } else {
            return <div className="suspended">{matchOdd.status}</div>
         }
      } else {
         return <div className="suspended">Suspended</div>
      }
   }

   const getSuspendedMatchOddsClass = (status, matchOdd) => {
      if (!checkAdminIsSuspend(matchOdd.marketId)) {
         if (matchOdd.status == "OPEN") {
            if (status != "ACTIVE") {
               return "lock"
            }
         } else {
            return "lock"
         }
      } else {
         return "lock"
      }
   }

   const setProfitloss = (marketId,runnerId) => {
      return <span className={`${ profitLossData[`${marketId}_${runnerId}`] > 0 ? "green-txt" : profitLossData[`${marketId}_${runnerId}`] < 0 ? "red-txt" : "" } book-value`}>{profitLossData[`${marketId}_${runnerId}`] || ""}</span>
   }

   const checkMaxOdds = (id,price) =>{
      if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
         //  if (data.marketId.toString() == 12926696 ) {
         //    console.log(data,"data?.max_odd");
         //  }
          if (data?.max_odd == 0) {
               return true;
          }else{
            return data?.max_odd > price;
          }
          }else{
              return false;
          }
   }

   const getSuspendedBookmaker = (status, bookmakerMarket1) => {
      if (!checkAdminIsSuspend(bookmakerMarket1.marketId)) {
         if (bookmakerMarket1.status === "OPEN") {
            if (status !== "ACTIVE") {
               return <div className="suspended">{status}</div>
            }
         } else {
            return <div className="suspended">{bookmakerMarket1.status}</div>
         }
      } else {
         return <div className="suspended">SUSPENDED</div>
      }
   }

   const getSuspendedBookmakerClass = (status, bookmakerMarket1) => {
      if (!checkAdminIsSuspend(bookmakerMarket1.marketId)) {
         if (bookmakerMarket1.status === "OPEN") {
            if (status !== "ACTIVE") {
               return "lock";
            }
         } else {
            return "lock";
         }
      } else {
         return "lock";
      }
   }

   function customSort(a, b) {
      const getNumber = (str) => {
          const match = str.match(/^(\d+)/); // Match leading numeric value
          return match ? parseInt(match[0], 10) : Infinity; // Use Infinity for non-numeric values
      };

      const numA = getNumber(a.marketName);
      const numB = getNumber(b.marketName);

      if (numA !== numB) {
          return numA - numB; // Sort numerically first
      }

      return a.marketName.localeCompare(b.marketName); // If numbers are equal, sort alphabetically
  }

  const handleResetBtn = () => {
     SendBookDetails_MB();
   setIsMobileBets(false);
   setIsBetSlipOpen(false);
   config.DATA = {
         stake: 0
   }
   setBetsData({
       eventId: '',
       marketId: '',
       stake: "",
       betType: '',
       selectionName: '',
       odds: '',
       secId: '',
       marketData:{},
       isCashout: false,
       isFancy:''
   });
}

const formatNumberinStack = (num) => {
   if (num >= 1000000000) {
     return (num / 1000000000) + 'B'; // Billion
   } else if (num >= 1000000) {
     return (num / 1000000) + 'M'; // Million
   } else if (num >= 1000) {
     return (num / 1000) + 'K'; // Thousand
   } else {
     return num; // Less than 1000
   }
 };

 const handleClear = () => {
   handleResetBtn();
   setBetsData((prev) => ({
     ...prev,
     stake: "0", // Setting stake to '0'
   }));
 };

 const handlePlceBets = () => {
   clearInterval(countIntervalId);
   setBetOnProcess(true);
   let user = JSON.parse(sessionStorage.getItem('userinfo'));
   sendMessage("createToken",{userName:user.userName});
}

const addValue = (item) => {
   let asd = parseFloat(betsData.stake || "0") + Number(item);
  config.DATA.stake = asd
   updateBook(betsData.stake,Number(item)+Number(betsData.stake))

   setBetsData(prev => ({
       ...prev,
       stake: asd
   }))
}

const handleIncrementOdds = (event) => {
   let newOdds =(parseFloat(betsData.odds || "0") + 0.01).toFixed(2)
   setBetsData(prevState => ({
       ...prevState,
       odds: newOdds
   }));
};

const handleDecrementOdds = (event) => {
   let newOdds =(parseFloat(betsData.odds || "0") - 0.01).toFixed(2)
   setBetsData(prevState => ({
       ...prevState,
       odds: newOdds
   }));
};

const handleClose = () => {
   setFancyBookPopup(false)
}

const getCurrentProfit = () => {
   if(betsData.betType === config.back){
      return profitLossData[`${betsData.marketData.marketId}_${betsData.secId}`];
   }else{
      return  profitLossData[`${betsData.marketData.marketId}_${betsData.marketData?.runners?.find(item => item.runnerId != betsData.secId).runnerId}`];
   }
}

   const getBetSlip = () => {
      let marketTypes = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN","TIED_MATCH", "OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15"].includes(betsData?.marketData?.marketType)
      return <div className={`bet-slip-container ${isBetSlipOpen ? 'open' : ''}`}>
            <div>
               <h4 className="bet-slip-title"> {t('Bet Slip')} </h4>
            </div>
            <div className={`bet-slip-box ${betsData.betType === config.back ? 'back' : 'lay'}`}>
               <div className="bet-slip">
                  <div className="bet-nation">
                  <span>{apiResponse?.matchData?.competitionName}</span>
                     <a className="close-bet" onClick={handleResetBtn}>
                        <img src="https://wver.sprintstaticdata.com/v108/static/front/img/close.svg" />
                     </a>
                  </div>
                  <div className="bet-team">
                  <span className="bet-team-name">{betsData.selectionName}</span>
                  <div className="match-result">{t(betsData.marketName)}</div>
                  </div>
               </div>
               <div className="bet-amount-box">
               <div className="bet-input back-border">
                  <input type="text" value={betsData.stake} maxlength="9" placeholder={t("Amount")} className="form-control"
                  onChange={(e) => {
                     let inputValue = e.target.value;
                     if (/^\d*\.?\d*$/.test(inputValue)) {
                        updateBook(betsData.stake, inputValue);
                        setBetsData((prev) => ({ ...prev, stake: inputValue }));
                        config.DATA.stake = inputValue
                     }
                  }}  />
                     </div>
                     <div className="odds-box">
                        <input type="number" value={betsData.isFancy === config.isNotfancy ? betsData.odds : betsData.rate} onChange={()=> ''} readOnly className="form-control" />
                        <span><img src="../images/arrow-down.svg" className="arrow-up" onClick={handleIncrementOdds}/></span>
                        <span><img src="../images/arrow-down.svg" className="arrow-down" onClick={handleDecrementOdds}/></span>
                     </div>

                     {betsData.isFancy === config.isNotfancy ? <div class="possible-win"><span>{t('profit')}</span> <h1 class="mb-0">{getCurrentProfit()}</h1></div>:''}
               </div>
               <div className="bet-buttons">
               {Array.isArray(stack) && stack.map((item,index) => (
                  <button key={index} id={`${item}`} className="btn" onClick={()=> addValue(item.value)}><span>{item.key}</span></button>
                           )) }

               </div>
               <div className="place-bet-btn">
                  <button className="btn clear" onClick={handleClear}>{t("clear")}</button>
                  <button className="btn" onClick={handlePlceBets}><span>{t('Place bet')}</span></button>
               </div>
            </div>
            {betsData.isFancy === config.isNotfancy ?
                              <div className='profit-loss-markts desktop-hide'>
                       {betsData.marketData?.runners && betsData.marketData?.runners.map((item,index) => (
                        <div id={index}>
                           <span>{item.runnerName}</span>
                           {setProfitloss(betsData.marketData?.marketId,item.runnerId)}
                        </div>
                        ))}
                       </div> : ''}
            <div className={`inner-loader ${betOnProcess? 'show':''}`}><img src={rip} alt="loder" height={'200px'} width={"200px"}/></div>
         </div>
   }

  const handleOnBackClick = (runner,betType,marketId,odds,isFancy,matchOdd) => {
   SendBookDetails_MB();
   if (sessionStorage.getItem('loggedIn') || loggedIn) {
      if (!betOnProcess){
         setIsBetSlipOpen(true);
         if (isFancy === config.isNotfancy) {
            config.DATA = {
                  eventId: eventId,
                  marketId: `${marketId}`,
                  stake: 0,
                  betType: betType,
                  selectionName: runner.runnerName,
                  odds: odds,
                  secId: `${runner.runnerId}`,
                  marketData:matchOdd,
                  marketName:matchOdd?.marketName,
                  isCashout: false,
                  isFancy:isFancy
            }
            setBetsData({
                  eventId: eventId,
                  marketId: `${marketId}`,
                  stake: '',
                  betType: betType,
                  selectionName: runner.runnerName,
                  odds: odds,
                  secId: `${runner.runnerId}`,
                  marketData:matchOdd,
                  marketName:matchOdd?.marketName,
                  isCashout: false,
                  isFancy:isFancy
            });
         }else{
            config.DATA = {
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.runnerName,
                   fancySecId: `${runner.runnerId}`,
                   odds: betType === config.back ? runner.backPrices[0].line : runner.layPrices[0].line,
                   rate: betType === config.back ? runner.backPrices[0].price : runner.layPrices[0].price,
                   marketName:runner.runnerName,
                   marketType:getTitleName(runner?.category),
                   isFancy:isFancy,
                  
             }

             setBetsData({
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.runnerName,
                   fancySecId: `${runner.runnerId}`,
                   odds: betType === config.back ? runner.backPrices[0].line : runner.layPrices[0].line,
                   rate: betType === config.back ? runner.backPrices[0].price : runner.layPrices[0].price,
                   marketName:runner.runnerName,
                   marketType:getTitleName(matchOdd?.category),
                   isFancy:isFancy,
                   
             });
         }
         if (isOneClicked === "true") {
            clearInterval(countIntervalId);
            setBetOnProcess(true);
            let user = JSON.parse(sessionStorage.getItem('userinfo'));
            sendMessage("createToken",{userName:user.userName});
         }
      }else{
         console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
      }
   }else{
      setLoginPop(true);
   }
   }

   const handleCashOutBM = (id,e) => {
      e.stopPropagation();
      let marketId = id;
      let userinfo = sessionStorage.getItem('userinfo');
      let eventID = eventId;
      if (userinfo && eventID) {
          userinfo = JSON.parse(userinfo);
          sendMessage('cashOOutBm', { id: marketId, user: userinfo, eventID });
      }
  };

   const handleCashOutMO = (id,e) => {
      e.stopPropagation();
      let marketId = id;
      let userinfo = sessionStorage.getItem('userinfo');
      let eventID = eventId;
      if (userinfo && eventID) {
          userinfo = JSON.parse(userinfo);
          sendMessage('cashOOut', { id: marketId, user: userinfo, eventID });
      }else{
      }
  };

   const isShowcashout = (id) => {
      if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
          return data?.isshowcashout
      }else{
          return false;
      }
  }
   const isCommission = (id) => {
      if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
          return data?.commissionstatus
      }else{
          return false;
      }
  }

  const getSubNotification = () => {
   let data = JSON.stringify({
       "eventId":eventId
   })
   const myHeaders = new Headers();
   myHeaders.append("Content-Type", "application/json");

   const requestOptions = {
     method: "POST",
     headers: myHeaders,
     redirect: "follow",
     body: data,
   };

   fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/notification/getmarketNotitfication`, requestOptions)
     .then(async (response) => {
       let paresData = await response.json();
       setMyNotification(paresData?.notifications);
       console.log(paresData?.notifications,"paresData?.notifications");

     })
     .catch((error) => {
       console.log(error);
     });
 }

  const handleShow = (marketId) => {
   setFancyBookPopup(true)

   let userinfo = sessionStorage.getItem('userinfo');
   if (userinfo && marketId) {
       userinfo = JSON.parse(userinfo);
       console.log(marketId,"marketIdmarketIdmarketIdmarketId");
       sendMessage('getFancyBookDATAuserSide', { id: marketId, user: userinfo });
   }
}

const getSportType = () => {
   if (apiResponse?.matchData?.sportId.toString() === "7" || apiResponse?.matchData?.sportId.toString() === '4339') {
       return true;
   }else{
       return false;
   }
}

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

const getTabHead = (matchData) => {
        if (matchData?.sportId == config.SpidCricket) {
         if (matchData?.isvirtual) {
            return {
               background: config.ColorVirtualCricket,
               color: '#fff'
             };
         }else{
            return {
               background: config.ColorCricket,
               color: '#fff'
             };
         }
        } else if (matchData?.sportId == config.SpidFootball) {
            return {
              background: config.ColorFootball,
              color: '#fff'
            };
        } else if (matchData?.sportId == config.SpidTennis) {
            return {
              background: config.ColorTenis,
              color: '#fff'
            };
        } else if (matchData?.sportId == config.SpidElection) {
            return {
              background: config.ColorElection,
              color: '#fff'
            };
        } else if (matchData?.sportId == config.SpidKabaddi) {
            return {
              background: config.ColorKabaddi,
              color: '#fff'
            };
        } else if (matchData?.sportId == config.SpidGreyhoundRacing) {
            return {
              background: config.ColorGreyhoundRacing,
              color: '#fff'
            };
        } else if (matchData?.sportId == config.SpidHorseRacing) {
            return {
              background: config.ColorHorseRacing,
              color: '#fff'
            };
        }else{
            return {}
        }
      };

      const checkStream = (scoresUrl,tvUrl) => {
         if (scoresUrl == '<div class=\"blank_livestream\"></div>' && tvUrl == '<div class=\"blank_livestream\"></div>') {
            return 'no-virtual-stream';
         }else if (scoresUrl == '<div class=\"blank_livestream\"></div>' && tvUrl != '<div class=\"blank_livestream\"></div>') {
            return 'hide-scorecard';
         }else if (scoresUrl != '<div class=\"blank_livestream\"></div>' && tvUrl == '<div class=\"blank_livestream\"></div>') {
            return 'hide-video-tv';
         }
      }

   const headerfun = () => {
      return <div className="betlist-header" style={getTabHead(apiResponse?.matchData)}>
      <div className="betlist-col">
         <div className="sport-title">
            {apiResponse?.matchData?.eventName} - {apiResponse?.matchData?.competitionName}
         </div>
         <div className='stearm-icon-mobile'>
         <span>
            <i className={`fas fa-tv ml-1 ${scoreOrTvLive==="TV"? 'active':''}`} onClick={()=>scoreOrTvLive === 'TV' ?setScoreOrTvLive(''):setScoreOrTvLive('TV')}></i>
         </span>
         </div>
      </div>
      <div className="betlist-col">
         <div className="match-date"> {apiResponse?.matchData?.openDate && formatDate(apiResponse?.matchData?.openDate)}</div>
      </div>
   </div>
   }

   const checkData = (session) => {
      // if (session.marketId == "12977756") {
      //    console.log(session.marketName,checkFancyAdminIsSuspend(session.marketId), session.status,"session.statussession.statussession.statussession.status");
      // }
   }

const getNotification = (id) =>{
   return myNotification && myNotification.length > 0 && <SubNotification isFancy={false} msg={myNotification && myNotification.find(noti => noti.marketId == id)?.notifications} />
}
useEffect(() => {
   document.body.classList.add("exchange_inPlay");
   return () => {
     document.body.classList.remove("exchange_inPlay");
   };
 }, []);

   const renderdata = () => {
      if(matchStatuss){
         if (matchStatuss === 1) {
            return (
               <>
         <div className='content-box w-sidebar exchange_inplay-sec' key={key}>
            <div className="left-content">
           
               <div className="betlist-wraper exchange_inplay">
               {config.isShowInplayInCasino ? <div className='desktop-hide'>
                  <Link to={`/live_casinoInPlay/${localStorage.getItem('casinoUrl')}`}><div className="blink-message"><i className="fas fa-info-circle"></i> <div className='blink-red-yellow'>{localStorage.getItem('casinoName')}</div></div></Link>
                  </div> :'' }

                  {apiResponse?.matchData?.isvirtual ?
                  <>
                  {headerfun()}
                  { matchCheck === 'IN_PLAY' ?<div className={`vertual-tv ${checkStream(scoresUrl,tvUrl)} `}>
                     <div className={`scorecard`}>
                        <ScroreCard url={scoresUrl} scoreOrTvLive={scoreOrTvLive} status={apiResponse?.matchData?.status}/> 
                     </div>
                     <div className={`video-tv open`}>
                        <LiveTV url={tvUrl} status={apiResponse?.matchData?.status}/> 
                     </div>
                  </div> :''}
                  
                  </>

                  :
                  <>
                  {scoresUrl && apiResponse && matchCheck === 'IN_PLAY' && <div className={`scorecard open`}> <ScroreCard url={scoresUrl} scoreOrTvLive={scoreOrTvLive} status={apiResponse?.matchData?.status}/> </div>}
                  <div className="mobile-setream">
                     <div className={`video-tv ${scoreOrTvLive==="TV"? 'open':''}`}>
                        {tvUrl && matchCheck === 'IN_PLAY' && <LiveTV url={tvUrl} status={apiResponse?.matchData?.status}/>}
                     </div>
                  </div>
                  {headerfun()}
                  </>
                   }

                  {apiResponse && matchOdd &&
                     Object.entries(matchOdd).map(([key, value]) => {
                        return (
                           <>
                           {!apiResponse.enableDisableArray.includes(key) ?
                              <Accordion key={key} id={key} transition transitionTimeout={250}>
                              <AccordionItem initialEntered header={
                                 <div className="betlist-header betlist-inner-header">
                                    <div className="betlist-col">
                                       <div className="sport-title">{t(value?.marketName)}{isCommission(value.marketId) ? <span className='blink'>*</span> :''}</div>
                                    </div>
                                    <div className='betlist-col'>
                                    <div className="cashout-btn">
                              {isShowcashout(value?.marketId) && receivedBetlistData  && value?.runners?.length === 2 && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                 <button onClick={(e)=>handleCashOutMO(value?.marketId,e)} className="btn btn-success btn-sm">{t('Cashout')}</button>) : value?.runners?.length === 2 ? <button disabled className="btn btn-success btn-sm">{t('Cashout')}</button> :''}
                              </div>
                                    </div>
                                    <div className='desktop-hide betlist-col'>
                                    <div className="max-bet">
                                       {getMyMinMax(value.marketId)}
                                    </div>
                                 </div>
                                 </div>
                              }>
                                 <div className="betlist" id={value.marketId}>
                                    <div className="betlist-row odds-heading">
                                       <div className="betlist-col">
                                          <div className="match-info">
                                             <span className="max-bet">
                                                {getMyMinMax(value.marketId)}
                                             </span>
                                          </div>
                                       </div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box"><span className="back">Back</span></div>
                                             <div className="box"><span className="lay">Lay</span></div>
                                          </div>
                                       </div>
                                    </div>

                                    {value?.runners?.length > 0 ? (
                                       value.runners.map((runner, index) => (
                                          <div className="betlist-row" id={runner.runnerId} key={index}>
                                             <div className="betlist-col">
                                                <div className="match-info">
                                                   <div className="match-name">
                                                      <p className="team-name sm">{runner.runnerName}</p>
                                                   </div>
                                                {setProfitloss(value?.marketId,runner.runnerId)}
                                                </div>
                                             </div>
                                             <div className="betlist-col odds-col">
                                                <div className="match-odds">
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                   <BackPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{ formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />
                                                   </div>
                                                   {getSportType() ? <div className='box'>
                                                   <span className="lay">{getLock()}</span>
                                                   <span className="lay1">{getLock()}</span>
                                                   <span className="lay2">{getLock()}</span>
                                                   </div>:
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                      <LayPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />
                                                   </div>}
                                                   {getSuspendedMatchOdds(runner.status,value)}
                                                </div>
                                             </div>
                                          </div>
                                       ))
                                    ) : (
                                       <p>Loading Match Odds market data...</p>
                                    )}
                                    {getNotification(value.marketId)}
                                 </div>
                              </AccordionItem>
                              </Accordion> :''}
                           </>

                        );
                     })
                  }

                  {apiResponse && bookmakerMarket &&
                     Object.entries(bookmakerMarket).map(([key, value]) => {
                        return (
                           <>{!apiResponse.enableDisableArray.includes(key) ?
                           <Accordion transition transitionTimeout={250}>

                              <AccordionItem initialEntered header={
                                 <div className="betlist-header betlist-inner-header">
                                 <div className="betlist-col">
                                    <div className="sport-title">{t(value?.marketName)}{isCommission(value.marketId) ? <span className='blink'>*</span> :''}</div>
                                 </div>
                                 <div className='betlist-col'>
                                 <div className="cashout-btn">
                           {isShowcashout(value.marketId) && value?.runners?.length === 2 && receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                              <button onClick={(e)=>handleCashOutBM(value?.marketId,e)} className="btn btn-success btn-sm">{t('Cashout')}</button>) : value?.runners?.length === 2 ? <button disabled className="btn btn-success btn-sm">{t('Cashout')}</button> :''}
                           </div>
                                 </div>
                                 <div className='desktop-hide betlist-col'>
                                    <div className="max-bet">
                                       {getMyMinMax(value.marketId)}
                                    </div>
                                 </div>
                              </div>}>
                                 <div className="betlist">
                                    <div className="betlist-row odds-heading">
                                       <div className="betlist-col">
                                          <div className="match-info">
                                             <span className="max-bet">
                                                {getMyMinMax(value.marketId)}
                                             </span>
                                          </div>
                                       </div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box"><span className="back">Back</span></div>
                                             <div className="box"><span className="lay">Lay</span></div>
                                          </div>
                                       </div>
                                    </div>

                                    {value?.runners?.length > 0 ? (
                                       value.runners.map((runner, index) => (
                                          <div className="betlist-row" id={runner.runnerId} key={index}>
                                             <div className="betlist-col">
                                                <div className="match-info">
                                                   <div className="match-name">
                                                      <p className="team-name sm">{runner.runnerName}</p>
                                                   </div>
                                                    {setProfitloss(value?.marketId,runner.runnerId)}
                                                </div>
                                             </div>
                                             <div className="betlist-col odds-col">
                                                <div className="match-odds">
                                                   <div className={`box ${getSuspendedBookmakerClass(runner.status, value)}`}>
                                                   <BMBackPriceBox runner={runner}
                                                      config={config}
                                                      value={value}
                                                      checkMaxOdds={checkMaxOdds}
                                                      validationBM={validationBM}
                                                      getLock={getLock}
                                                      handleOnBackClick={handleOnBackClick}
                                                      getBMBoxValue={getBMBoxValue}/>
                                                   </div>
                                                   <div className={`box ${getSuspendedBookmakerClass(runner.status, value)}`}>
                                                   <BMLayPriesBox
                                                      runner={runner}
                                                      config={config}
                                                      value={value}
                                                      checkMaxOdds={checkMaxOdds}
                                                      validationBM={validationBM}
                                                      getLock={getLock}
                                                      handleOnBackClick={handleOnBackClick}
                                                      getBMBoxValue={getBMBoxValue} />
                                                   </div>
                                                   {getSuspendedBookmaker(runner.status,value)}
                                                </div>
                                             </div>
                                          </div>
                                       ))
                                    ) : (
                                       <p>Loading Match Odds market data...</p>
                                    )}
                                    {getNotification(value.marketId)}
                                 </div>
                              </AccordionItem>
                           </Accordion> :''}
                           </>
                        );
                     })
                  }

                  {apiResponse && underOver &&
                     Object.entries(underOver).map(([key, value]) => {
                        return (<>
                           {!apiResponse.enableDisableArray.includes(key) ?
                           <Accordion key={key} id={key} transition transitionTimeout={250}>
                              <AccordionItem initialEntered header={
                                 <div className="betlist-header betlist-inner-header">
                                    <div className="betlist-col">
                                       <div className="sport-title">{value?.marketName}{isCommission(value.marketId) ? <span className='blink'>*</span> :''}</div>
                                    </div>
                                    <div className='betlist-col'>
                                    <div className="cashout-btn">
                              {isShowcashout(value?.marketId) && receivedBetlistData && value?.runners?.length === 2 && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                 <button onClick={(e)=>handleCashOutMO(value?.marketId,e)} className="btn btn-success btn-sm">{t('Cashout')}</button>) : value?.runners?.length === 2 ? <button disabled className="btn btn-success btn-sm">{t('Cashout')}</button> :''}
                              </div>
                                    </div>
                                    <div className='desktop-hide betlist-col'>
                                    <div className="max-bet">
                                       {getMyMinMax(value.marketId)}
                                    </div>
                                 </div>
                                 </div>
                              }>
                                 <div className="betlist" id={value.marketId}>
                                    <div className="betlist-row odds-heading">
                                       <div className="betlist-col">
                                          <div className="match-info">
                                             <span className="max-bet">
                                                {getMyMinMax(value.marketId)}
                                             </span>
                                          </div>
                                       </div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box"><span className="back">Back</span></div>
                                             <div className="box"><span className="lay">Lay</span></div>
                                          </div>
                                       </div>
                                    </div>

                                    {value?.runners?.length > 0 ? (
                                       value.runners.map((runner, index) => (
                                          <div className="betlist-row" id={runner.runnerId} key={index}>
                                             <div className="betlist-col">
                                                <div className="match-info">
                                                   <div className="match-name">
                                                      <p className="team-name sm">{runner.runnerName}</p>
                                                   </div>
                                                {setProfitloss(value?.marketId,runner.runnerId)}
                                                </div>
                                             </div>
                                             <div className="betlist-col odds-col">
                                                <div className="match-odds">
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                   <BackPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />

                                                      {/* <span className={`back2 ${checkMaxOdds(value?.marketId,runner.backPrices?.[2]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[2]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[2]?.price) ? getBoxValue(runner.backPrices?.[2]) : getLock()}
                                                      </span>
                                                      <span className={`back1 ${checkMaxOdds(value?.marketId,runner.backPrices?.[1]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[1]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[1]?.price) ? getBoxValue(runner.backPrices?.[1]) : getLock()}
                                                      </span>
                                                      <span className={`back ${checkMaxOdds(value?.marketId,runner.backPrices?.[0]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[0]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[0]?.price) ? getBoxValue(runner.backPrices?.[0]) : getLock()}
                                                      </span> */}
                                                   </div>
                                                   {getSportType() ? <div className='box'>
                                                   <span className="lay">{getLock()}</span>
                                                   <span className="lay1">{getLock()}</span>
                                                   <span className="lay2">{getLock()}</span>
                                                   </div>:
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                      {/* <span className={`lay ${checkMaxOdds(value?.marketId,runner.layPrices?.[0]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[0]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[0]?.price) ? getBoxValue(runner.layPrices?.[0]) : getLock()}
                                                      </span>
                                                      <span className={`lay1 ${checkMaxOdds(value?.marketId,runner.layPrices?.[1]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[1]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[1]?.price) ? getBoxValue(runner.layPrices?.[1]) : getLock()}
                                                      </span>
                                                      <span className={`lay2 ${checkMaxOdds(value?.marketId,runner.layPrices?.[2]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[2]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[2]?.price) ? getBoxValue(runner.layPrices?.[2]) : getLock()}
                                                      </span>
                                                      <Lay2Span
                                                      runner={runner}
                                                      marketId={value.marketId}
                                                      config={config}
                                                      value={value}
                                                      checkMaxOdds={checkMaxOdds}
                                                      validationBM={validationBM}
                                                      getLock={getLock}
                                                      handleOnBackClick={handleOnBackClick}
                                                      /> */}
                                                      <LayPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />
                                                   </div>}
                                                   {getSuspendedMatchOdds(runner.status,value)}
                                                </div>
                                             </div>
                                          </div>
                                       ))
                                    ) : (
                                       <p>Loading Match Odds market data...</p>
                                    )}
                                    {getNotification(value.marketId)}
                                 </div>
                              </AccordionItem>
                           </Accordion>
                           :''}</>
                        );
                     })
                  }

                  <div className="row gap-0">
                  {hasAnyFancyType &&
                  <> {!apiResponse.enableDisableArray.includes("Normal") ? <div className="col-12">
                           <Accordion transition transitionTimeout={250}>
                              <AccordionItem
                                 initialEntered
                                 header={
                                    <div className="betlist-header betlist-inner-header">
                                       <div className="betlist-col">
                                          <div className="sport-title">{t("Normal")}</div>
                                       </div>
                                    </div>
                                 }
                              >
                              <div className="betlist row gap-0">
                              <div className="betlist-row by-col2 col-6 odds-heading">
                                    <div className="betlist-col"></div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box">
                                                <span className="lay">No</span>
                                             </div>
                                             <div className="box">
                                                <span className="back">Yes</span>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="betlist-col min-max-profit"><div className="max-bet"></div></div>
                                    </div>
                                    <div className="betlist-row by-col2 col-6 odds-heading">
                                    <div className="betlist-col"></div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box">
                                                <span className="lay">No</span>
                                             </div>
                                             <div className="box">
                                                <span className="back">Yes</span>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="betlist-col min-max-profit"><div className="max-bet"></div></div>
                                    </div>

                              {fancyNormalType.map((type) => (
                                 fancyData?.filter((item) => item.category === type).length > 0 && (
                                    fancyData?.filter((item) => item.category === type).sort(type === "OVERS" ? customSort : undefined).map((value, index) => (
                                       <div className="col-6" id={value.marketId} key={index}>
                                       {checkData(value)}
                                       <div className='betlist-row by-col2'>
                                          <div className="betlist-col">
                                             <div className="match-info">
                                                <div className="match-name">
                                                   <p className="team-name">{value.marketName}</p>
                                                </div>
                                                {
                                                            receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId.toString() === value.marketId.toString()).length > 0 ? (
                                                                <span className={`fancy-book-btn ${getMyBookcheck(value.marketId) ?'green-txt':'red-txt'}`} onClick={() => handleShow(value.marketId)}>{getMyBook(value.marketId)}</span>
                                                            ) : null
                                                        }
                                             </div>
                                          </div>
                                          <div className="betlist-col odds-col">
                                          <div>

                                          {value.runners.filter(item => item.status && item.status !== 'SUSPENDED').length === 0 ? (
                                          <div className="match-odds">
                                             <div className={`box lock`}>
                                                <span className='market-odd-box lay'>
                                                   <span className='market-odd'>{getLock}</span>
                                                </span>
                                             </div>
                                             <div className={`box lock`}>
                                                <span className='market-odd-box back'>
                                                   <span className='market-odd'>{getLock}</span>
                                                </span>
                                             </div>
                                             <div className="suspended">SUSPENDED</div>
                                          </div>
                                          ) : (

                                             value.runners.filter(item => item.status && item.status !== 'SUSPENDED').map((runnerItem,runnerIndex)=>(
                                                <div className="match-odds">
                                          <div className={`box ${isFancySuspend(value)}`}>
                                             <FLayPriesBox runner={runnerItem}
                                                value={value}
                                                checkMaxOdds={checkMaxOdds}
                                                validation={validation}
                                                getLock={getLock}
                                                handleOnBackClick={handleOnBackClick} />
                                                </div>
                                             <div className={`box ${isFancySuspend(value)}`}>
                                               <FBackPriceBox runner={runnerItem}
                                                   value={value}
                                                   checkMaxOdds={checkMaxOdds}
                                                   validation={validation}
                                                   getLock={getLock}
                                                   handleOnBackClick={handleOnBackClick} />
                                                </div>
                                                {fancySuspend(value)}

                                                </div>
                                             ))
                              )}
                                          </div>
                                          </div>
                                          <div className="betlist-col min-max-profit">{getMyMinMax(value.marketId)}</div>
                                       </div>
                                       {getNotification(value.marketId)}
                                       </div>
                                    ))
                              )
                           ))}
                           </div>
                              </AccordionItem>
                           </Accordion>
                     </div>:''}</>}

                     {fancyType.map((type) => (
                        fancyData?.filter((item) => item.category === type).length > 0 && (
                           <>
                           {!apiResponse.enableDisableArray.includes(getName(type)) ?
                           <div className="col-12" key={type}>
                           <Accordion transition transitionTimeout={250}>
                              <AccordionItem
                                 initialEntered
                                 header={
                                    <div className="betlist-header betlist-inner-header">
                                       <div className="betlist-col">
                                          <div className="sport-title">{t(getTitleName(type))}</div>
                                       </div>
                                    </div>
                                 }
                              >
                                 <div className="betlist row gap-0">
                                    <div className="betlist-row by-col2 col-6 odds-heading">
                                    <div className="betlist-col"></div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box">
                                                <span className="lay">No</span>
                                             </div>
                                             <div className="box">
                                                <span className="back">Yes</span>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="betlist-col min-max-profit"><div className="max-bet"></div></div>
                                    </div>
                                    <div className="betlist-row by-col2 col-6 odds-heading">
                                    <div className="betlist-col"></div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box">
                                                <span className="lay">No</span>
                                             </div>
                                             <div className="box">
                                                <span className="back">Yes</span>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="betlist-col min-max-profit"><div className="max-bet"></div></div>
                                    </div>

                                    {fancyData?.filter((item) => item.category === type).sort(type === "OVERS" ? customSort : undefined).map((value, index) => (
                                       <div className="col-6" id={value.marketId} key={index}>
                                          <div className='betlist-row by-col2 test'>
                                          <div className="betlist-col">
                                             <div className="match-info">
                                                <div className="match-name">
                                                   <p className="team-name">{value.marketName}</p>
                                                </div>
                                                {
                                                            receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId.toString() === value.marketId.toString()).length > 0 ? (
                                                                <span className={`fancy-book-btn ${getMyBookcheck(value.marketId) ?'green-txt':'red-txt'}`} onClick={() => handleShow(value.marketId)}>{getMyBook(value.marketId)}</span>
                                                            ) : null
                                                        }
                                             </div>
                                          </div>
                                          <div className="betlist-col odds-col">
                                             <div>

                                          {value.runners.filter(item => item.status && item.status !== 'SUSPENDED').length === 0 ? (
                                          <div className="match-odds">
                                             <div className={`box lock`}>
                                                <span className='market-odd-box lay'>
                                                   <span className='market-odd'>{getLock}</span>
                                                </span>
                                             </div>
                                             <div className={`box lock`}>
                                                <span className='market-odd-box back'>
                                                   <span className='market-odd'>{getLock}</span>
                                                </span>
                                             </div>
                                             <div className="suspended">SUSPENDED</div>
                                          </div>
                                          ) : (

                                             value.runners.filter(item => item.status && item.status !== 'SUSPENDED').map((runnerItem,runnerIndex)=>(
                                                <div className="match-odds">
                                          <div className={`box ${isFancySuspend(value)}`}>
                                             <FLayPriesBox runner={runnerItem}
                                                value={value}
                                                checkMaxOdds={checkMaxOdds}
                                                validation={validation}
                                                getLock={getLock}
                                                handleOnBackClick={handleOnBackClick} />
                                                </div>
                                             <div className={`box ${isFancySuspend(value)}`}>
                                               <FBackPriceBox runner={runnerItem}
                                                   value={value}
                                                   checkMaxOdds={checkMaxOdds}
                                                   validation={validation}
                                                   getLock={getLock}
                                                   handleOnBackClick={handleOnBackClick} />
                                                </div>
                                                {fancySuspend(value)}

                                                </div>
                                             ))
                                             )}
                                          </div>
                                          </div>
                                          <div className="betlist-col min-max-profit">{getMyMinMax(value.marketId)}</div>
                                       </div>
                                       {getNotification(value.marketId)}
                                       </div>
                                    ))}
                                 </div>
                              </AccordionItem>
                           </Accordion>
                        </div>:''}
                        </>
                        )
                     ))}
                  </div>

                  {apiResponse && tideMatch &&
                     Object.entries(tideMatch).map(([key, value]) => {
                        return (
                           <>
                           {!apiResponse.enableDisableArray.includes(key) ?
                           <Accordion key={key} id={key} transition transitionTimeout={250}>
                              <AccordionItem initialEntered header={
                                 <div className="betlist-header betlist-inner-header">
                                    <div className="betlist-col">
                                       <div className="sport-title">{t(value?.marketName)}{isCommission(value.marketId) ? <span className='blink'>*</span> :''}</div>
                                    </div>
                                    <div className='betlist-col'>
                                    <div className="cashout-btn">
                              {isShowcashout(value?.marketId) && value?.runners?.length === 2 && receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                 <button onClick={(e)=>handleCashOutMO(value?.marketId,e)} className="btn btn-success btn-sm">{t('Cashout')}</button>) : value?.runners?.length === 2 ? <button disabled className="btn btn-success btn-sm">{t('Cashout')}</button> :''}
                              </div>
                                    </div>
                                    <div className='desktop-hide betlist-col'>
                                    <div className="max-bet">
                                       {getMyMinMax(value.marketId)}
                                    </div>
                                 </div>
                                 </div>
                              }>
                                 <div className="betlist" id={value.marketId}>
                                    <div className="betlist-row odds-heading">
                                       <div className="betlist-col">
                                          <div className="match-info">
                                             <span className="max-bet">
                                                {getMyMinMax(value.marketId)}
                                             </span>
                                          </div>
                                       </div>
                                       <div className="betlist-col odds-col">
                                          <div className="match-odds bk-ly-heading">
                                             <div className="box"><span className="back">Back</span></div>
                                             <div className="box"><span className="lay">Lay</span></div>
                                          </div>
                                       </div>
                                    </div>

                                    {value?.runners?.length > 0 ? (
                                       value.runners.map((runner, index) => (
                                          <div className="betlist-row" id={runner.runnerId} key={index}>
                                             <div className="betlist-col">
                                                <div className="match-info">
                                                   <div className="match-name">
                                                      <p className="team-name sm">{runner.runnerName}</p>
                                                   </div>
                                                {setProfitloss(value?.marketId,runner.runnerId)}
                                                </div>
                                             </div>
                                             <div className="betlist-col odds-col">
                                                <div className="match-odds">
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                   <BackPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />

                                                      {/* <span className={`back2 ${checkMaxOdds(value?.marketId,runner.backPrices?.[2]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[2]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[2]?.price) ? getBoxValue(runner.backPrices?.[2]) : getLock()}
                                                      </span>
                                                      <span className={`back1 ${checkMaxOdds(value?.marketId,runner.backPrices?.[1]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[1]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[1]?.price) ? getBoxValue(runner.backPrices?.[1]) : getLock()}
                                                      </span>
                                                      <span className={`back ${checkMaxOdds(value?.marketId,runner.backPrices?.[0]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.back,value.marketId, runner.backPrices?.[0]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.backPrices?.[0]?.price) ? getBoxValue(runner.backPrices?.[0]) : getLock()}
                                                      </span> */}
                                                   </div>
                                                   {getSportType() ? <div className='box'>
                                                   <span className="lay">{getLock()}</span>
                                                   <span className="lay1">{getLock()}</span>
                                                   <span className="lay2">{getLock()}</span>
                                                   </div>:
                                                   <div className={`box ${getSuspendedMatchOddsClass(runner.status, value)}`}>
                                                      {/* <span className={`lay ${checkMaxOdds(value?.marketId,runner.layPrices?.[0]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[0]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[0]?.price) ? getBoxValue(runner.layPrices?.[0]) : getLock()}
                                                      </span>
                                                      <span className={`lay1 ${checkMaxOdds(value?.marketId,runner.layPrices?.[1]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[1]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[1]?.price) ? getBoxValue(runner.layPrices?.[1]) : getLock()}
                                                      </span>
                                                      <span className={`lay2 ${checkMaxOdds(value?.marketId,runner.layPrices?.[2]?.price ?? 0) ? 'disable':''}`} onClick={()=>handleOnBackClick(runner,config.lay,value.marketId, runner.layPrices?.[2]?.price,config.isNotfancy,value)}>
                                                         {validationBM(runner.layPrices?.[2]?.price) ? getBoxValue(runner.layPrices?.[2]) : getLock()}
                                                      </span>
                                                      <Lay2Span
                                                      runner={runner}
                                                      marketId={value.marketId}
                                                      config={config}
                                                      value={value}
                                                      checkMaxOdds={checkMaxOdds}
                                                      validationBM={validationBM}
                                                      getLock={getLock}
                                                      handleOnBackClick={handleOnBackClick}
                                                      /> */}
                                                      <LayPricesBox
                                                         runner={runner}
                                                         config={config}
                                                         value={value}
                                                         checkMaxOdds={checkMaxOdds}
                                                         validationBM={validationBM}
                                                         getLock={getLock}
                                                         handleOnBackClick={handleOnBackClick}
                                                         getBoxValue={(lay) => (
                                                            <>
                                                               {lay.price}
                                                               {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                            </>
                                                         )}
                                                         />
                                                   </div>}
                                                   {getSuspendedMatchOdds(runner.status,value)}
                                                </div>
                                             </div>
                                          </div>
                                       ))
                                    ) : (
                                       <p>Loading tide Match market data...</p>
                                    )}
                                    {getNotification(value.marketId)}
                                 </div>
                              </AccordionItem>
                           </Accordion>:''}
                           </>
                        );
                     })
                  }

               </div>
            </div>
            <div className="right-content sidebar">
            {config.isShowInplayInCasino && localStorage.getItem('casinoUrl') ? <div className='mobile-hide'>
               <Link to={`/live_casinoInPlay/${localStorage.getItem('casinoUrl')}`}><div className="blink-message"><i className="fas fa-info-circle"></i> <div className='blink-red-yellow'>{localStorage.getItem('casinoName')}</div> </div></Link>
            </div> :''}

           { !apiResponse?.matchData?.isvirtual ? <div className='sidebar-box livestream'>
               <div className={`tv-title ${isStreamOpen? 'active':''}`} onClick={()=>setStreamOpen(!isStreamOpen)}><h4 className="mb-0 bet-slip-title">{t('tv')}</h4> <i className={`fas fa-angle-${isStreamOpen? 'up':'down'}`}></i></div>
                  <div className={`video-tv ${isStreamOpen? 'open':''}`}>

                  {tvUrl && <LiveTV url={tvUrl} status={apiResponse?.matchData?.status}/>}

                  </div>
            </div>:''
           }
            <div className='sidebar-box'>
            {getBetSlip()}
            {(receivedBetlistData?.bets?.MatchOdds.length > 0 ||
                  receivedBetlistData?.bets?.bookmaker.length > 0 ||
                  receivedBetlistData?.bets?.normal.length > 0 ||
                  receivedBetlistData?.bets?.oddEven.length > 0) &&
                  <div className='bet-listed'>
                  <div className='bet-title'>MY BETS</div>
                  <div className={`bets-table ${receivedBetlistData?.bets?.MatchOdds.length > 0 ? 'show' : ''}`}>
                     <div className={`bets-table-title ${isOpen === "Match Odds" ? 'active' :''}`} onClick={() => handleClick("Match Odds")}>Match Odds ({receivedBetlistData?.bets?.MatchOdds.length})</div>
                     <div className={`table-responsive ${isOpen === "Match Odds" ? 'show' :''}`}>
                     <table className='table'>
                        {receivedBetlistData?.bets?.MatchOdds?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                  </div>
                  <div className={`bets-table ${receivedBetlistData?.bets?.bookmaker.length > 0 ? 'show' : ''}`}>
                     <div className={`bets-table-title ${isOpen === "Bookmaker" ? 'active' :''}`} onClick={() => handleClick("Bookmaker")}>Bookmaker ({receivedBetlistData?.bets?.bookmaker.length})</div>
                     <div className={`table-responsive ${isOpen === "Bookmaker" ? 'show' :''}`}>
                     <table className='table'>
                        {receivedBetlistData?.bets?.bookmaker?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                  </div>
                  <div className={`bets-table ${receivedBetlistData?.bets?.normal.length > 0 ? 'show' : ''}`}>
                     <div className={`bets-table-title ${isOpen === "Normal" ? 'active' :''}`} onClick={() => handleClick("Normal")}>Normal ({receivedBetlistData?.bets?.normal.length})</div>
                     <div className={`table-responsive ${isOpen === "Normal" ? 'show' :''}`}>
                     <table className='table'>
                        {receivedBetlistData?.bets?.normal?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                  </div>
                  <div className={`bets-table ${receivedBetlistData?.bets?.oddEven.length > 0 ? 'show' : ''}`}>
                     <div className={`bets-table-title ${isOpen === "Odd Even" ? 'active' :''}`} onClick={() => handleClick("Odd Even")}>Odd Even ({receivedBetlistData?.bets?.oddEven.length})</div>
                     <div className={`table-responsive ${isOpen === "Odd Even" ? 'show' :''}`}>
                     <table className='table'>
                        {receivedBetlistData?.bets?.oddEven?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                  </div>
               </div>
               }
            </div>
            </div>
            <div className={`bets-sticky ${receivedBetlistData?.bets?.bets.length > 0 ? 'show' :''}`} onClick={()=>setIsMobileBets(true)}>{receivedBetlistData?.bets?.bets.length}</div>
            <FancyBookPopup isFancyBookPopup={isFancyBookPopup} handleClose={handleClose} receivedBookFancy={receivedBookFancy} />
         </div>
         <GloblePopup
                  isOpen={isBetSlipOpen}
                  onClose={() => handleResetBtn()}
                  title={t('Bet Slip')}
                  cancelText="Close"
                  className="placebet-modal mobilebets"
               >
               {getBetSlip()}
               </GloblePopup>

               <GloblePopup
                  isOpen={isMobileBets}
                  onClose={() => handleResetBtn()}
                  title="MY BETS"
                  cancelText="Close"
                  className="mybets-modal"
               >
               <>
               <h6>Matched Bets</h6>
               <div className="my-market-container">
                  <div className="market-tabs">
                     <a className="arrow-tabs arrow-left">
                        <img src="https://wver.sprintstaticdata.com/v112/static/front/img/arrow-down.svg"/>
                     </a>
                     <ul className="nav nav-tabs">
                        {receivedBetlistData?.bets?.MatchOdds.length > 0 ? <li className="nav-item" onClick={()=>setIsMobileBetsOpen("Match Odds")}><a data-toggle="tab" className="nav-link active">Match Odds ({receivedBetlistData?.bets?.MatchOdds.length})</a></li> :'' }
                        {receivedBetlistData?.bets?.bookmaker.length > 0 ? <li className="nav-item" onClick={()=>setIsMobileBetsOpen("bookmaker")}><a data-toggle="tab" className="nav-link active">Bookmaker ({receivedBetlistData?.bets?.bookmaker.length})</a></li> :''}
                        {receivedBetlistData?.bets?.normal.length > 0 ? <li className="nav-item" onClick={()=>setIsMobileBetsOpen("normal")}><a data-toggle="tab" className="nav-link active">Normal ({receivedBetlistData?.bets?.normal.length})</a></li>:""}
                        {receivedBetlistData?.bets?.oddEven.length > 0 ? <li className="nav-item" onClick={()=>setIsMobileBetsOpen("oddEven")}><a data-toggle="tab" className="nav-link active">Odd Even ({receivedBetlistData?.bets?.oddEven.length})</a></li>:''}
                     </ul>
                     <a className="arrow-tabs arrow-right">
                        <img src="https://wver.sprintstaticdata.com/v112/static/front/img/arrow-down.svg"/>
                     </a>
                  </div>
                  <div className="bet-slip-box tab-content">
                     <div className={`tab-pane ${isMobileBetsOpen === "Match Odds"?'active':''}`}>
                        <div className="bet-slip">
                           <div className={`table-responsive ${isMobileBetsOpen === "Match Odds" ? 'show' :''}`}>
                           <table className='table'>
                           {receivedBetlistData?.bets?.MatchOdds?.map((item, index) => (
                              <tr key={index}  className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                                 <td>{item?.selectionName}</td>
                                 <td>{item?.oddValue}</td>
                                 <td>{item?.marketName}</td>
                                 <td>{item?.Stake}</td>
                              </tr>
                           ))}
                        </table>
                     </div>
                     </div>
                     </div>

                     <div className={`tab-pane ${isMobileBetsOpen === "bookmaker"?'active':''}`}>
                        <div className="bet-slip">
                           <div className={`table-responsive ${isMobileBetsOpen === "bookmaker" ? 'show' :''}`}>
                           <table className='table'>
                           {receivedBetlistData?.bets?.bookmaker?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                     </div>
                     </div>


                     <div className={`tab-pane ${isMobileBetsOpen === "normal"?'active':''}`}>
                        <div className="bet-slip">
                           <div className={`table-responsive ${isMobileBetsOpen === "normal" ? 'show' :''}`}>
                           <table  className='table'>
                           {receivedBetlistData?.bets?.normal?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                     </div>
                     </div>
                     <div className={`tab-pane ${isMobileBetsOpen === "oddEven"?'active':''}`}>
                        <div className="bet-slip">
                           <div className={`table-responsive ${isMobileBetsOpen === "oddEven" ? 'show' :''}`}>
                           <table className='table'>
                           {receivedBetlistData?.bets?.oddEven?.map((item, index) => (
                           <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}-border`}>
                              <td>{item?.selectionName}</td>
                              <td>{item?.oddValue}</td>
                              <td>{item?.marketName}</td>
                              <td>{item?.Stake}</td>
                           </tr>
                        ))}
                        </table>
                     </div>
                     </div>
                     </div>
                  </div>
               </div>
               </>
               </GloblePopup> 
               </>
            );
         }else if (matchStatuss === 0) {
            return ('');
         }else{
            return(<MatchNotFound/>)
         }
      }
   }

   return (
      <>
       {renderdata()}
      </>
   )

}
